export default __webpack_public_path__ + "static/P_SearchThumb_IN-6001HD-986d6ff15e77b7c1fd94f1afd82e1fc5.webp";